export default __webpack_public_path__ + "assets/malawi-flag.png";